import { EventTypeId } from './eventType';

const americanSports = [
  EventTypeId.AMERICAN_FOOTBALL,
  EventTypeId.BASEBALL,
  EventTypeId.BASKETBALL,
  EventTypeId.ICE_HOCKEY
] as const satisfies readonly EventTypeId[];

export const isAmericanEventType = (eventTypeId: EventTypeId): eventTypeId is AmercianEventType =>
  americanSports.includes(eventTypeId as AmercianEventType);

export type AmercianEventType = (typeof americanSports)[number];
